import { Col, Row } from '@opendoor/atoms/box';
import { Image } from '@opendoor/atoms/image';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import { IconLogout2, IconShield, IconTruckDelivery } from '@tabler/icons-react';

import {
  PDP_GUARANTEE_SEAL_SOURCES,
  PDP_GUARANTEE_SEAL_SRCSET,
  PDP_GUARANTEE_SEAL_URL,
} from './media';

const PROTECTIONS = [
  { icon: IconTruckDelivery, label: 'Early move in' },
  { icon: IconShield, label: '100-Day Warranty' },
  { icon: IconLogout2, label: 'Free cancellation' },
];

export const PdpGuaranteeCard = () => (
  <Col
    as="section"
    aria-label="The Opendoor Guarantee"
    className="w-full gap-5 rounded-[18px] bg-od-bg-tertiary px-6 py-5"
  >
    <Link
      href="https://help.opendoor.com/buying/making-an-offer/opendoor-guarantee"
      target="_blank"
      rel="noopener noreferrer"
      analyticsName="cosmos-marketplace-pdp-guarantee-learn-more"
      className="flex items-center gap-3! no-underline!"
    >
      <Image
        src={PDP_GUARANTEE_SEAL_URL}
        srcSet={PDP_GUARANTEE_SEAL_SRCSET}
        sources={PDP_GUARANTEE_SEAL_SOURCES}
        alt=""
        width={48}
        height={48.5}
        className="block shrink-0"
      />
      <Col className="gap-1">
        <Text as="p" className="text-label-md text-od-content-primary">
          The Opendoor Guarantee
        </Text>
        <Text as="p" className="text-body-sm text-od-content-secondary">
          Included with this home
        </Text>
      </Col>
    </Link>
    <Row className="flex-wrap gap-1">
      {PROTECTIONS.map(({ icon: Icon, label }) => (
        <Row key={label} className="items-center gap-2 rounded-full bg-od-bg-primary px-3 py-2">
          <Icon size={16} className="shrink-0 text-od-content-inactive-primary" aria-hidden />
          <Text as="span" className="whitespace-nowrap text-body-xs text-od-content-primary">
            {label}
          </Text>
        </Row>
      ))}
    </Row>
  </Col>
);
